import { createSelector } from "@reduxjs/toolkit";

import { RootState } from "../../index";
import { arrayToObjectByField } from "Utils";
import { DataStatus } from "../../types";

export const getVdaActionDefinitions = (
  state: RootState
): VdaActionDefinition[] => state.vdaActionDefinitions.data;

export const getVdaActionDefinitionsById = createSelector(
  getVdaActionDefinitions,
  (vdaActionDefinitions) => arrayToObjectByField(vdaActionDefinitions)
);

const getVdaActionDefinitionsStatus = (state: RootState) =>
  state.vdaActionDefinitions.status;

export const getIsVdaActionDefinitionsLoaded = createSelector(
  getVdaActionDefinitionsStatus,
  (status) => status === DataStatus.succeeded
);

export const getIsVdaActionDefinitionsLoading = createSelector(
  getVdaActionDefinitionsStatus,
  (status) => status === DataStatus.loading
);

export const getIsVdaActionDefinitionsLoadingError = createSelector(
  getVdaActionDefinitionsStatus,
  (status) => status === DataStatus.failed
);
